import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { identitySchema } from '@/core/components';

import { jobTitleList } from '@feature/utils';

export const setupSchema = z.object({
  lastName: z.string().min(3),
  firstName: z.string().min(3),

  jobTitle: z.enum(jobTitleList),
  faculty: identitySchema,
  department: identitySchema,
  discipline: identitySchema,
});

export const defaultSetupValues: DefaultValues<SetupSchema> = {
  firstName: '',
  lastName: '',
};

export type SetupSchema = z.infer<typeof setupSchema>;
